const headerStyle = (theme) => ({
  appBar: {
    display: "flex",
    border: "0",
    borderRadius: "3px",
    padding: "0px",
    color: "white",
    width: "100%",
    backgroundColor: "#fff",
    transition: "all 150ms ease 0s",
    alignItems: "center",
    flexFlow: "row nowrap",
    justifyContent: "flex-start",
    position: "relative",
    zIndex: "1100",
    boxShadow: "0 0 8px 1px rgb(3 130 153 / 8%)",
  },
  container: {
    flex: "1",
    alignItems: "center",
    justifyContent: "space-between",
    display: "flex",
    flexWrap: "nowrap",
    padding: "0px",
    minHeight: "initial",
    flexDirection: "column",
    color: "white",
  },
  menulist: {},

  sectionLinks: {
    background: "linear-gradient(90deg, #00839B 45.01%, #013C44 95.16%)",
    height: "44px",
    "@global": {
      a: {
        color: "white",
        textDecoration: "initial",
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: "14px",
        lineHeight: "24px",
        color: "white",
        paddingLeft: "36px",
        paddingRight: "36px",
      },
    },
  },
  sectionLinks2: {
    backgroundColor: "#00839B",
    height: "51px",
    "@global": {
      a: {
        color: "white",
        textDecoration: "initial",
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: "14px",
        lineHeight: "24px",
        color: "white",
        paddingLeft: "36px",
        paddingRight: "36px",
      },
    },
  },
  icon: {
    marginLeft: "10px",
  },
  middleSection: {
    paddingTop: "25px",
    paddingBottom: "25px",
    paddingLeft: "3%",
    paddingRight: "3%",
    "@global": {
      a: {
        textDecoration: "initial",
        color: "#191716",
        fontWeight: "normal",
        fontSixe: "16px",
        lineHeight: "24px",
      },
    },
  },
  subLinks: {
    "&:hover": {
      "@global": {
        ".dropdownList": {
          display: "block !important",
        },
      },
    },
  },
  ckbd: {
    display: "none",
    zIndex: 1,
    position: "absolute",
    minWidth: "205px",
    boxShadow: "0px 8px 16px 0px rgb(0 0 0 / 20%)",
    marginTop: "15px",
    marginLeft: "34px",
    paddingTop: "15px",
    backgroundColor: "white",
    "@global": {
      div: {
        paddingLeft: "25px",
        paddingBottom: "25px",
      },
      a: {
        color: "black !important",
      },
    },
  },
  drawerPaper: {
    border: "none",
    bottom: "0",
    transitionProperty: "top, bottom, width",
    transitionDuration: ".2s, .2s, .35s",
    transitionTimingFunction: "linear, linear, ease",
    width: "96%",
    boxShadow:
      "0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)",
    position: "fixed",
    display: "block",
    top: "0",
    height: "100vh",
    right: "auto",
    left: "0",
    visibility: "visible",
    overflowY: "visible",
    borderTop: "none",
    textAlign: "left",

    transition: "all 150ms ease 0s",
    overflow: "auto",
  },
  drawerLinks: {
    margin: ".5em",
    "& > a": {
      textDecoration: "none",
      backgroundColor: "transparent",
      outline: "none",
      cursor: "pointer",
      color: "#505E7B !important",
      fontSize: "16px",
    },
  },
  footer: {
    position: "relative",
    bottom: "0",
    left: "0",
    width: "100%",
    backgroundColor: "#005F71",
    padding: "58px",
    color: "white",
    top: "10px",
    "@global": {
      a: {
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: "16px",
        lineHeight: "24px",
        textDecoration: "initial",
        color: "#FFFFFF",
      },
    },
  },
  InputMail: {
    width: "90%",
    background: "#F2F8F9",
    borderRadius: "5px",
    order: "0",
    padding: "16px 16px",
    height: "50px",
    fontFamily: "visuelt-regular",
    [theme.breakpoints.up("sm")]: {
      width: "100% !important",
    },
    [theme.breakpoints.up("md")]: {
      width: "100% !important",
    },
    [theme.breakpoints.up("xs")]: {
      width: "100% !important",
    },
  },
  MailBtn: {
    maxWidth: "178px",
    padding: "14px 27px",
    minHeight: "51px",
    background: "#FF5C3C",
    borderRadius: "5px",
    border: "none",
    color: "#fff",
    fontWeight: "600",
    fontFamily: "visuelt-regular",
    [theme.breakpoints.up("sm")]: {
      width: "100% !important",
    },
    [theme.breakpoints.up("md")]: {
      width: "100% !important",
    },
    [theme.breakpoints.up("xs")]: {
      width: "100% !important",
    },
  },
  title: {
    fontFamily: "visuelt-regular",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "28px",
    textTransform: "uppercase",
    color: "#92D5E6",
    paddingBottom: "12px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
  },
  group: {
    display: "flex",
    justifyContent: "center",
    gap: "5px",
    width: "100px",
    alignItems: "center",
    [theme.breakpoints.up("sm")]: {
      width: "45px !important",
    },
    [theme.breakpoints.up("xs")]: {
      width: "45px !important",
    },
  },
  hideDiv: {
    position: "absolute",
    background: "white",
    top: "92%",
    padding: "2px 30px",
    borderRadius: "5px",
    cursor: "pointer",
    boxShadow: "0px 0px 1px 0px black",
    right: "8px",
    zIndex: 999,
    [theme.breakpoints.up("md")]: {
      right: "0 !important",
      top: "135% !important",
    },
  },
  hideDivElements: {
    marginTop: "3px",
    marginBottom: "1px",
    padding: "5px",
    color: "#15408D",
  },
  downloadLink: {
    justifyContent: "center",
  },
});

export default headerStyle;
